/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
/* eslint-disable no-alert */
import Vue from 'vue'
import qs from 'qs'
import debounce from 'lodash/debounce'
import UserService from '@services/user/api'
import OrderService from '@services/order/api'
import AddressService from '@services/address/api'
import { getClosestMetro } from '@helpers/addressInput'
import Item from '@services/order/dotItemAdapter'
import listValidator from '@helpers/listValidator'
import getFormattedTime from '@helpers/getFormattedTime'
import getCurrentDateObj from '@helpers/getCurrentDateObj'
import getFormattedDotDate from '@apps/order-form/src/helpers/getFormattedDotDate'

export default {
  /**
   * Отмена запроса
   * @param {requestNames} requestName название запроса
   */
  cancelRequest({ state }, requestName) {
    if (!requestName) return

    const requestAbortHandler = state.requestAbortControllers[requestName]

    if (requestAbortHandler) {
      requestAbortHandler.abort()
      state.requestAbortControllers[requestName] = null
    }
  },

  resetServices({ commit, state }) {
    state.services = []
    commit('createServices', state.defaultServices) // Создаём новые
  },

  // Установка изначальных значений перед отображением формы.
  async setInitialState({ state, getters, commit, dispatch }, formProps = null) {
    if (!formProps) return

    const props = formProps

    // Записываем присланные пропы
    commit('setBaseState', props)

    // Записываем текущее время
    dispatch('updateCurrentDate')

    // Инициализируем стандартный заказ
    commit('createOrder', getters)

    // Собираем услуги
    commit('createDefaultServices')
    commit('createServices', props.form.clearServices)

    // Инициализируем список доступных дат и времен
    commit('createAllDates')
    commit('createAllTimes')

    if (state.base.isAdmin) await dispatch('getMetroList')

    if (state.base.isEdit) {
      await dispatch('setDeliveryObject', {
        template: state.form.deliveryObject,
        isAlias: false,
        isEdit: state.base.isEdit,
        isRestart: state.base.isRestart,
      })
    }

    if (state.form.deliveryObject) {
      state.order.dots.forEach((dot, index) => {
        const value =
          index === 0
            ? state.form.deliveryObject.pickupDot.metroId
            : state.form.deliveryObject.deliveryDots[index - 1].metroId

        const data = [
          {
            key: 'metroId',
            value,
          },
        ]

        commit('updateDot', { dot: state.order.dots[index], data })
      })
    }

    // Если попали на страницу через мини-форму на главной странице
    if (getters.isAnonimousForm) {
      let miniOrder = localStorage.getItem('miniOrder')

      if (miniOrder) {
        miniOrder = JSON.parse(miniOrder)
        miniOrder.dots.forEach((dot, index) => {
          const data = []

          Object.keys(dot).forEach(key => {
            data.push({
              key,
              value: dot[key],
            })
          })
          commit('updateDot', {
            dot: state.order.dots[index],
            data,
          })
        })
        commit('updateDeliveryMethod', miniOrder.chosenType.id)
        localStorage.removeItem('miniOrder')
      }
    }

    commit('updateFormLoading', false)
  },

  async incrementStep({ commit, dispatch }) {
    if (await dispatch('validateForm')) {
      commit('incrementStep')

      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 100)
    }
  },

  decrementStep({ commit }) {
    setTimeout(() => {
      commit('decrementStep')
      window.scrollTo(0, 0)
    }, 100)
  },

  approveUserPhone: ({ state, commit }) => {
    const phone = state.approveUser.phoneNumber

    commit('validateApproveUserCode', false)
    commit('updateApproveUser', {})

    UserService.checkPhoneAvailable(qs.stringify({ phone }))
      .then(data => {
        commit('updateApproveUserStatus', data.status)
      })
      .catch(error => {
        console.log('error', error)
      })
  },

  approveUserSendCode: async ({ state, commit, dispatch }, countArg = 0) => {
    let count = countArg

    if (count > 3) {
      throw new Error('Превышен лимит попыток генерации токена подтверждения пользователя')
    }

    let data = {
      phoneExistsNeedApprove: +state.approveUser.phoneStatus === 2 ? 1 : 0,
      phone: state.approveUser.phoneNumber,
    }

    try {
      data.token = await state.tokenGenerator()

      data = qs.stringify(data)
      commit('updateApproveUserCodeFetchingStatus')

      const response = await UserService.sendRegistryCode(data)

      commit('updateApproveUserMessage', response.msg)
      commit('updateApproveUserStatus', response.status)
      commit('updateApproveUserCodeFetchingStatus', false)
    } catch (error) {
      console.error('error', error)
      dispatch('approveUserSendCode', (count += 1))
    }
  },

  approveUserCheckCode: async ({ state, commit, dispatch }) => {
    const requestData = qs.stringify({
      phone: state.approveUser.phoneNumber,
      code: state.approveUser.code,
    })

    try {
      const response = await UserService.checkRegistryCode(requestData)

      commit('updateApproveUserStatus', response.status)
      commit('updateApproveUserMessage', response.msg)

      if (response.status === 0) {
        commit('updateApproveUser', response.user)
        commit('validateApproveUserCode')
        commit('updateAppToken', response.token)
        dispatch('submitOrder')
        dispatch('loadServicesList')
      }
    } catch (e) {
      console.error('error', e)
    }
  },

  showMapModal({ commit }, dot) {
    commit('setSelectedDot', dot)
    commit('toggleModals', 'selectionOnMap')
  },

  checkValidPromocode: debounce(({ state, commit, dispatch }) => {
    const data = {
      user: state.user.id,
      promo_code: state.order.promocode.value,
    }

    if (state.base.isEdit) data.order_id = state.order.id
    else data.edit = +state.base.isEdit

    OrderService.checkPromocode(data).then(result => {
      commit('validPromocode', result.data)

      if (result.data === 0) {
        dispatch('calculatePrice')
      }
    })
  }, 2000),

  async setDraftSuggestion({ commit, dispatch }, payload) {
    const suggestion = payload?.suggestion || payload
    const targetDot = payload?.targetDot || null

    const requestData = qs.stringify({
      tid: suggestion.tid,
    })

    try {
      const response = await OrderService.getDraft(requestData)
      const deliveryObject = qs.parse(response.template.json_draft)

      // Удаляем дату из шаблона, она всегда в прошедшем времени.
      delete deliveryObject.date

      commit('setSelectedTemplate', response.suggestion)
      dispatch('setDeliveryObject', {
        deliveryObject,
        targetDot,
      })
    } catch (e) {
      dispatch('showErrorMessage', 'Что-то пошло не так. Не удалось загрузить точку отправки.')
    }
  },

  // Получение списка станций метро при первоначальной загрузке страницы
  async getMetroList({ getters, commit }) {
    const data = {
      cityId: +getters.selectedCity.id || 1,
    }

    AddressService.getMetroList(data)
      .then(resData => {
        commit('updateState', {
          key: 'metroList',
          value: resData,
        })
      })
      .catch(e => {
        console.error(e)
        Vue.$toast.error('Произошла ошибка. Не удалось загрузить список станций метро.')
      })
  },

  checkAndFixCity({ getters, commit }, cityID) {
    if (cityID && getters.selectedCity.id !== cityID) {
      commit('changeCity', +cityID)
    }
  },

  async setDeliveryObject({ state, getters, commit, dispatch }, payloadData) {
    // Оставляем обратную совместимость, где передаётся только объект доставки и добавляем возможную целевую точку
    const payload = payloadData?.deliveryObject || payloadData
    const targetDot = payloadData?.targetDot || null
    const targetDotIndex = getters.getDotIndex(targetDot)

    // Обрабатываем случаи когда передаётся точка доставки без товаров
    if (targetDotIndex > 0 && !payload.pickupDot?.items?.length) {
      payload.pickupDot.items = [new Item()]
    }

    // Костыль, решающий проблему конфликта фронта и бека (остался со старых времен)
    // для бека 2 — это оплата с баланса, а для фронта — бонусами.
    // Необходимо исправить.
    const resolveDelPaymentMethod = val =>
      // if (+val === 2) {
      //   return 3
      // }
      //
      // if (+val === 3) {
      //   return 2
      // }

      +val

    // Функция для приведения времени в нужный формат
    const formatTime = val => {
      const hours = `${Math.floor(val / 3600)}`.padStart(2, '0')
      const minutes = `${Math.floor((val % 3600) / 60)}`.padStart(2, '0')

      return `${hours}:${minutes}`
    }

    // Функция для приведения даты в нужный формат
    const formatDate = dataArg => {
      let date = dataArg

      if (`${date}`.length <= 10) {
        date = +`${date}000`
      }

      date = +date - 10800000
      return date
    }

    // Фунция для сбора инфы о точке перед установкой
    const formatDotData = dotArg => {
      const dot = dotArg

      const formatText = textArg => {
        if (!textArg) return null

        let text = textArg.toString()

        if (text && text.slice(-2) === ', ') {
          text = text.slice(0, -2)
        }

        if (text) {
          text = text.trim()
        }

        return text
      }

      // Добавляем приписки к полям
      const addPostscripts = (val, name) => {
        if (val) {
          const value = val.toString()

          switch (name) {
            case 'storey':
              if (!value.startsWith(state.postscripts.storey)) {
                return state.postscripts.storey + value
              }

              break

            case 'apartment':
              if (!value.startsWith(state.postscripts.apartment)) {
                return state.postscripts.apartment + value
              }

              break

            case 'entrance':
              if (!value.startsWith(state.postscripts.entrance)) {
                return state.postscripts.entrance + value
              }

              break

            default:
              return value
          }
        }

        return val
      }

      const getPhone = () => {
        if (dot.phone[0] === '7') return dot.phone.slice(1, 99)
        if (dot.phone.slice(0, 2) === '+7') return dot.phone.slice(2, 99)

        return dot.phone
      }

      const dotResult = {
        id: dot?.id ? +dot.id : null,
        address: formatText(dot?.address),
        suburb: dot?.city || dot?.prigorodName || '',
        street: formatText(dot?.street) || '',
        building: formatText(dot?.building) || '',
        apartment: addPostscripts(dot?.apartment, 'apartment'),
        storey: addPostscripts(dot?.storey, 'storey'),
        entrance: addPostscripts(dot?.entrance, 'entrance'),
        metro: +dot.metroId,
        isMetro: dot.isMetro,
        contact: dot.contact,
        cash: +dot.cash || 0,
        phone: getPhone(),
        date: dot.date ? formatDate(dot.date) : null,
        timeFrom:
          dot.timeFrom && dot.timeFrom.toString().includes(':')
            ? dot.timeFrom
            : dot.timeFrom
            ? formatTime(dot.timeFrom)
            : null,
        timeTo:
          dot.timeTo && dot.timeTo.toString().includes(':')
            ? dot.timeTo
            : dot.timeTo
            ? formatTime(dot.timeTo)
            : null,
        comment: dot.comment,
        lat: +dot.lat,
        lng: +dot.lng,
        items: dot.items || [],
        distanceFromMetro: +dot.distanceFromMetro,
        isSuggestionSet: true,

        isSuburb: dot.isPrigorod,
        rightFormattedAddress: dot.rightFormattedAddress ? dot.rightFormattedAddress : '',
        isMetroNotFound: !!+dot.metroNotFound,
        deliveryExtraPay: getters.isBuyout ? null : +dot.deliveryExtraPay || null,
      }

      if (payloadData.isEdit && !payloadData.isRestart) {
        dotResult.initialDate = dotResult.date
        dotResult.initialTimeFrom = dotResult.timeFrom
        dotResult.initialTimeTo = dotResult.timeTo
      }

      const formattedDot = {}

      Object.keys(dotResult).forEach(key => {
        if (dotResult[key] !== null) {
          formattedDot[key] = dotResult[key]
        }
      })

      return formattedDot
    }

    try {
      if (payload.template) {
        const { isAdmin, isEdit, isRestart } = state.base
        const { template, isAlias } = payload
        const { info, deliveryDots, pickupDot, payServices, courierComission } = template

        state.courierComission = courierComission

        dispatch('checkAndFixCity', +pickupDot.cityId)

        const shopInfo = [
          {
            key: 'name',
            value: info.shopName,
          },
          {
            key: 'orderInnerId',
            value: info.shopInnerId,
          },
          {
            key: 'surcharge',
            value: +info.courierAddition || '',
          },
        ]

        commit('updateShop', shopInfo)

        let isSetPaymentMethod = false

        deliveryDots.forEach((el, ind) => {
          if (+el.isPaymentDot && info.deliveryPaymentMethod !== 4) {
            isSetPaymentMethod = true
            commit('setPaymentMethod', deliveryDots.length > 1 ? `10${ind + 1}` : ind + 1)
          }
        })

        const orderInfo = [
          {
            key: 'id',
            value: info.orderId,
          },
          {
            key: 'initStatus',
            value: info.status,
          },
          {
            key: 'deliveryMethod',
            value: +info.typeAuto,
          },
          {
            key: 'incomeReturnMethod',
            value: getters.isBuyout ? 0 : +info.incomeReturnMethod || 0,
          },
          {
            key: 'wallet',
            value: getters.isBuyout ? '' : info.incomeReturnCardNumber || '',
          },
        ]

        if (!isSetPaymentMethod || (payload && isAlias)) {
          orderInfo.push({
            key: 'paymentMethod',
            value: resolveDelPaymentMethod(+info.deliveryPaymentMethod),
          })
        }

        commit('updateOrder', orderInfo)
        commit('updatePromocode', info.promoCode || null)
        commit('updateState', { key: 'chosenCrmCourier', value: payload.template.info.crm_courier })

        const firstDotData = formatDotData(pickupDot)
        const orderData = []

        // Подставляем данные первой точки
        Object.keys(firstDotData).forEach(key => {
          orderData.push({
            key,
            value: firstDotData[key],
          })
        })
        commit('updateDot', {
          dot: state.order.dots[0],
          data: orderData,
        })
        // Если есть точки доставки, то оставляем только первую...
        if (deliveryDots.length) {
          commit('removeDeliveryDots')
          commit('resetNextItemIndex')
          // И создаем нужное кол-во точек. Также подставляем в них данные
          deliveryDots.forEach(dot => {
            const orderDotData = {}
            const deliveryStoreData = formatDotData(dot, {
              addItemIfEmpty: true,
            })

            Object.keys(deliveryStoreData).forEach(key => {
              if (!isEdit && key === 'cash' && info.paymentMethod === 1) {
                deliveryStoreData[key] = 1
              }

              orderDotData[key] = deliveryStoreData[key]
            })
            console.log(orderDotData)
            commit('createDot', orderDotData)
          })
        }

        // В случае если есть хоть какие-то отмеченные платные услуги, и это не режим редактирования
        if (payServices && payServices.length) {
          state.services.forEach(service => {
            // eslint-disable-next-line no-param-reassign
            service.isChecked = payServices.includes(service.alias)
          })
        }

        // костыль по таску
        if (!isEdit && state.user.isLegalEntity) {
          commit('setIncomeReturnMethod', 3)
        }

        state.order.dots.forEach(dot => {
          if (!dot.address) {
            return
          }

          // отправляем запрос на getClosestMetro для получения актуальных кординат и ближайших метро,
          // чтобы пришел корректный чек
          if (dot.city === '') {
            dispatch('getAddressSuggestions', dot.address)
          }
        })

        // Если заполнено хоть одно поле в доп. опциях, то раскрываем соответствующий блок
        if (info.shopName || info.shopInnerId || +info.courierAddition) {
          commit('updateState', {
            key: 'isExtraDetailsVisible',
            value: true,
          })
        }

        // Дожидаемся окончания валидации ввсех полей формы.
        await dispatch('validateForm')

        // Проверка промокода
        // dispatch('checkPromo');
        // проверка доп суммы за платную доставку.
        // dispatch('manageExtraPay');
        // Запуск процесса валидации всей формы
        // dispatch('validateForm');

        // Отображаем сообщение при успешной подстановке шаблона/черновика
        if (!isAdmin && !isEdit) {
          Vue.$toast.success('Шаблон успешно задан.', { position: 'top' })
        }

        // Скрываем окно с шаблонами
        commit('toggleModals')
      } else {
        // Если передана целевая точка - выбираем её, в противном случае - точка отправителя
        const pickupDot = targetDot || state.order.dots[0]
        const dotData = formatDotData(payload.pickupDot) // Оставил для обратно совместимости

        dispatch('checkAndFixCity', +payload.pickupDot.cityId)

        const formattedData = []

        Object.keys(dotData).forEach(key => {
          formattedData.push({
            key,
            value: dotData[key],
          })
        })

        commit('updateDot', {
          dot: pickupDot,
          data: formattedData,
        })
      }
    } catch (error) {
      Vue.$toast.error('Произошла ошибка. Не удалось задать шаблон.')
      // Скрываем окно с шаблонами
      commit('toggleModals')
      throw error
    }
  },

  // Экшн сохранения черновика
  async saveDraft({ commit, dispatch }, draft) {
    const data = { ...draft }
    const draftData = await dispatch('getDraftData', data.is_suggestion)

    data.json_draft = qs.stringify(draftData)

    const response = await UserService.saveDraft(data)

    const newTemplate = {
      ...data,
      tid: response.id,
    }

    commit('addDraft', newTemplate)

    return response
  },

  async getDraftData({ state, getters }, isSuggestion) {
    const { paymentDot } = state.order
    const firstDot = state.order.dots[0]
    const deliveryDots = state.order.dots.slice(1)

    // Приведение времени
    const resolveDraftTime = time => {
      const timeArr = time.split(':')
      const hours = +timeArr[0]
      const minutes = +timeArr[1] === 0 ? 0 : 0.5

      return (hours + minutes) * 3600
    }

    // Приведение даты
    const resolveDraftDate = date => {
      const dateValues = state.form.allDates.map(obj => obj.value)

      const closestDate = dateValues.reduce((prev, curr) =>
        Math.abs(curr - date) < Math.abs(prev - date) ? curr : prev
      )

      return closestDate
    }

    const formatDot = (dot, index = 0, options = {}) => {
      const data = {
        cityId: getters.selectedCity.id,
        prigorodName: dot.suburb,
        city: dot.suburb || getters.selectedCity.name,
        address: dot.address,
        street: dot.street,
        building: dot.building,
        comment: dot.comment,
        phone: dot.phone,
        contact: dot.contact,
        apartment: dot.apartment,
        entrance: dot.entrance,
        storey: dot.storey,
        distanceFromMetro: dot.distanceFromMetro,
        isPrigorod: dot.isSuburb,
        isPaymentDot: +(+paymentDot === index + 1),
        lat: dot.lat,
        lng: dot.lng,
        metroId: dot.metroId,
        metroNotFound: dot.isMetroNotFound,
        chequeCreated: dot.chequeCreated || 0,
        isMetro: dot.isMetro,
        deliveryExtraPay: dot.deliveryExtraPay,
        cash: dot.cash,
      }

      if (options.time) {
        data.timeFrom = resolveDraftTime(dot.timeFrom)
        data.timeTo = resolveDraftTime(dot.timeTo)
        data.date = resolveDraftDate(dot.date)
      }

      if (options.time) {
        data.items = dot.items.map(item => ({
          name: item.name,
          weight: item.weight,
          price: item.price,
          count: item.count,
        }))
      }

      return data
    }

    if (isSuggestion) {
      return {
        pickupDot: formatDot(firstDot),
      }
    }

    console.log(state.paymentDot)

    return {
      info: {
        typeAuto: state.order.deliveryMethod,
        itemShortName: 'Заказ',
        deliveryPaymentMethod: state.order.paymentMethod,
        incomeReturnMethod: state.order.incomeReturnMethod,
        incomeReturnCardNumber: state.order.wallet,
        shopName: state.order.shop.name,
        shopInnerId: state.order.shop.orderInnerId,
        courierAddition: state.order.shop.surcharge,
        promoCode: state.order.promocode.value,
        paymentDot: +state.order.paymentDot || null,
      },
      pickupDot: formatDot(firstDot, { time: true }),
      deliveryDots: deliveryDots.map((dot, index) =>
        formatDot(dot, index, {
          time: true,
          items: true,
        })
      ),
      // Исключаем "Срочное редактирование" из запросов на создание шаблона
      payServices: getters.addedServices
        .filter(service => service.alias !== 'd_late_edit')
        .map(service => service.alias),
    }
  },

  async checkIfPhoneAvailable({ commit, dispatch, state }, phone) {
    commit('startFormFetching')

    try {
      const data = await UserService.checkPhoneAvailable(qs.stringify({ phone }))

      commit('setPhoneCheckStatus', data.status)
    } catch (e) {
      console.error(e)
    } finally {
      commit('startFormFetching', false)
      if (+state.phoneCheckStatus === 2) dispatch('loadUser', phone)
    }
  },

  async regUser({ commit, dispatch }, data) {
    commit('startFormFetching')

    const { phone } = data
    const requestData = qs.stringify({ data })

    try {
      await UserService.registerByPhone(requestData)

      dispatch('loadUser', phone)
    } catch (e) {
      console.error(e)
      dispatch('showErrorMessage', e.message)
    } finally {
      commit('startFormFetching', false)
    }
  },

  loadUser({ commit, dispatch }, phone) {
    commit('startFormFetching', true)

    const requestData = qs.stringify({ phone })

    UserService.getUserWithTemplates(requestData)
      .then(data => {
        commit('replaceState', {
          key: 'user',
          value: data.user,
        })
        commit('replaceState', {
          key: 'selectedUser',
          value: data.user,
        })

        commit('replaceState', {
          key: 'form',
          value: data.form,
        })

        commit('replaceState', {
          key: 'base',
          value: data.base,
        })

        dispatch('changeCity', data.user.cityId)
        dispatch('toggleServicesbyUserLoad')
      })
      .catch(e => {
        Vue.$toast.error(e.message)
        console.error(e)
      })
      .finally(() => {
        commit('startFormFetching', false)
      })
  },
  toggleServicesbyUserLoad({ state, commit }) {
    if (state.user.isLastOrderCanceled && !!state.services.find(el => el.id === 35)) {
      commit('turnOnService', 35)
    }

    if (state.form.createdByPhone && !!state.services.find(el => el.id === 27)) {
      commit('turnOnService', 27)
    }
  },

  async calculatePrice({ commit, dispatch }) {
    commit('startFormFetching')

    await dispatch('getCheckPrint')
    await dispatch('checkEnoughTime')
  },

  // Отправка запроса на получение чека со стоимостью заказа
  getCheckPrint: debounce(async ({ state, getters, commit, dispatch }) => {
    try {
      commit('startFormFetching')

      // отменяем прошлый запрос
      dispatch('cancelRequest', 'getCheckPrint')
      // устанавливаем новый контроллер
      commit('setAbortController', 'getCheckPrint')

      const requestData = qs.stringify(getters.buildedOrder)

      const data = await OrderService.getCheckPrint(requestData, {
        signal: state.requestAbortControllers.getCheckPrint.signal,
      })

      commit('setAdvanceCheque', data.checkPrint)

      state.order.dots.forEach(() => {
        // commit('updatePaymentMethods', data.pay_metods) - не работает в форме без реги, заменил на vue.set
        Vue.set(state.form, 'deliveryPaymentMethods', data.pay_metods)
        commit('updateState', { key: 'isShowPaymentMethods', value: true })
        commit('updateServices', data.services)
        commit('updateState', { key: 'courierComission', value: data.courierComission })
        commit('updateState', { key: 'isHighDemand', value: data.high_demand })
      })
    } catch (e) {
      console.error('Не удалось рассчитать стоимость доставки.', e.message)
    } finally {
      commit('startFormFetching', false)
      commit('setAbortController', 'getCheckPrint')
    }
  }, 600),

  async deleteSuggestion({ commit, dispatch }, draft) {
    try {
      await OrderService.deleteOrderDraft({ id: draft.tid })
      commit('deleteSuggestionLocal', draft.tid)
    } catch (e) {
      dispatch('showErrorMessage', e)
    }
  },

  /**
   * Проверка всей формы
   * @returns {boolean} вся ли форма валидка
   */
  validateForm({ state }) {
    return listValidator(state.validatorsList)
  },

  createOrderPostProcess({ state }, _order) {
    const order = structuredClone(_order)

    /** Пост обработчик точек */
    const handleDots = dots => {
      // Обработка времени "с" в точках
      const timeFromHandled = dots.map((dot, idx) => {
        if (!state.isCurrentTime[idx]) return dot

        const now = new Date()

        // Добавляем ещё минуту к текущему временни для бэка
        now.setMinutes(now.getMinutes() + 1)

        const newCurrentTimeFrom = getFormattedDotDate(now)

        return {
          ...dot,
          dateFrom: newCurrentTimeFrom,
        }
      })

      // Возращаем точки после всех обработок
      return timeFromHandled
    }

    order.Dots = handleDots(order.Dots)

    // Возвращаем обработанный объект заказа
    return order
  },

  async submitOrder({ state, getters, commit, dispatch }) {
    if (!(await dispatch('validateForm'))) return

    const { isAdmin, isEdit, isRestart } = state.base
    const { order, user } = state

    if (getters.totalItemsPrice > getters.maxItemsCost) {
      Vue.$toast.error(
        `Суммарная стоимость товаров превышает максимально допустимую. Фактическая: ${getters.totalItemsPrice} руб; Максимальная: ${getters.maxItemsCost} руб.`
      )

      return
    }

    if (isAdmin && !state.selectedUser && !isEdit) {
      dispatch('showErrorMessage', 'Необходимо выбрать или зарегистрировать пользователя')
      return
    }

    // Если хоть одна из точек далеко от метро, то предупреждаем об этом пользователя
    if (getters.isFarFromMetro) {
      if (
        !window.confirm(
          'Внимание! Пешкарики не гарантируют выполнение заказа по указанным Вами параметрам (км).'
        )
      ) {
        return
      }
    }

    if (getters.isAnonimousForm && !state.approveUser.isValided) {
      commit('toggleModals', 'approvePhone')
      return
    }

    if (!order.selectedCard && order.paymentMethod === 5) {
      try {
        await dispatch('getUrlToBindNewCard') // Выполняем запрос
        commit('toggleModals', 'bindNewCard') // Если запрос успешен, показываем модалку
      } catch (error) {
        return // Если произошла ошибка, просто выходим из функции
      }
      return
    }

    if (!state.isFormFetching) {
      // Собираем данные для запроса только, если запрос не в статусе pending
      commit('startFormFetching', true)

      let data = await dispatch('createOrderPostProcess', getters.buildedOrder)

      if (!isEdit && !getters.isAnonimousForm) {
        const draftDot = order.dots[0]
        const draftAlias = `${draftDot.address} ${draftDot.building}`

        if (!state.form.orderDraft.find(suggestion => suggestion.alias === draftAlias)) {
          const draftData = {
            user_id: user.id,
            alias: draftAlias,
            is_suggestion: 1,
          }

          dispatch('saveDraft', draftData)
        }
      }

      // Приводим данные в строку
      data = qs.stringify(data)

      try {
        const response =
          isEdit && !isRestart
            ? await OrderService.editOrder(data)
            : await OrderService.createOrder(data)

        const { orderId, message } = response

        commit('startFormFetching', false)

        commit('updateOrder', {
          key: 'id',
          value: +orderId,
        })

        if (isAdmin) {
          window.alert('Заказ успешно запущен!')
          window.location.href = `/admin/order/edit/${orderId}`
          return
        }

        if (isRestart) {
          commit('toggleModals', 'orderCreated')
          commit('setOrderCreatedMessage', 'Заказ перезапущен!')
          dispatch('sendMetriks', 'restart_button')
          return
        }

        if (isEdit) {
          commit('toggleModals', 'orderCreated')
          commit('setOrderCreatedMessage', 'Заказ отредактирован!')
          return
        }

        if (!getters.isAnonimousForm) {
          commit('toggleModals', 'orderCreated')
          dispatch('sendMetriks', 'new_form_order_created')
        } else {
          const savedOrder = {
            orderMessage: response.message,
            base: state.base,
            order: state.order,
            additional: state.additional,
            services: state.services,
          }

          dispatch('sendMetriks', 'push_order')
          localStorage.setItem('savedOrder', JSON.stringify(savedOrder))
          setTimeout(() => {
            dispatch('moveToOrdersList')
          }, 500)
        }

        commit('setOrderCreatedMessage', message)

        // Задаем оверфлоу документу, чтоб не крутился под модалкой
        // document.body.style.overflowY = 'hidden'
      } catch (error) {
        console.error(error)
        dispatch('blockOrderButton')
        commit('startFormFetching', false)
        dispatch('showErrorMessage', error.message)
        // Обновляем текущую дату
        // dispatch('updateCurrentDate')
      }
    }
  },

  async sendMetriks({ getters }, type) {
    if (typeof ym !== 'undefined') {
      ym(41864514, 'reachGoal', type)
    }

    if (getters.isAnonimousForm) {
      if (typeof VK !== 'undefined') {
        VK.Retargeting.Event('vk_orderCreated')
        VK.Retargeting.Add(27460298)
      }

      if (typeof _tmr !== 'undefined') {
        _tmr.push({ type: 'reachGoal', id: 3309779, goal: 'push_order' })
      }

      if (typeof gtag !== 'undefined') {
        gtag('event', 'Created order', { event_category: 'click', event_action: 'created_order' })
      }

      if (typeof ga !== 'undefined' && typeof ga.push === 'function') {
        ga.push(['_trackEvent', 'zakazchiki', 'click_button1'])
      }
    } else if (!getters.isAnonimousForm && typeof _tmr !== 'undefined') {
      _tmr.push({ type: 'reachGoal', id: 3309779, goal: 'new_form_order_created' })
    }
  },

  showErrorMessage({ commit }, errorMessage) {
    let message = errorMessage

    if (typeof message !== 'string') {
      try {
        setTimeout(() => {
          throw message
        })
        message = errorMessage.response.message
      } catch (error) {
        message =
          'Произошла ошибка, попробуйте позже, в случае повторения ошибки обратитесь в службу поддержки.'
      }
    }

    Vue.$toast.error(message, { duration: 10000, position: 'top' })
    commit('setWarningMessage', {
      body: message,
    })
    commit('toggleModals', 'warningMessage')
  },

  async getUrlToBindNewCard({ state, commit, dispatch }) {
    try {
      // Определяем userID
      const userID = state.base.isAdmin ? state.selectedUser.id : state.user.id

      // Данные для привязки карты
      const cardData = {
        user_id: userID,
        sum: 1,
        binding_id: null,
        bindingCardToService: 1,
        action: 1,
      }

      // Асинхронный запрос
      const res = await OrderService.bindCard(cardData)

      if (res.data.success) {
        // Успех: сохраняем ссылку
        commit('setUrlToBindNewCard', res.data.paymentUrl)
      } else {
        // Ошибка: выбрасываем исключение с сообщением
        throw new Error('Не удалось получить ссылку для привязки карты.')
      }
    } catch (error) {
      // Показываем сообщение об ошибке через Vuex
      await dispatch('showErrorMessage', error.message || 'Произошла ошибка.')
      // Обязательно выбрасываем ошибку дальше
      throw error
    }
  },


  cleanDotsAddress: ({ state, commit }) => {
    const { dots } = state.order

    dots.forEach(dot => commit('cleanDotAddress', dot))
  },

  changeCity({ state, commit, dispatch }, cityId) {
    if (state.order.city === cityId) return
    commit('changeCity', cityId)
    dispatch('updateCurrentDate')
    dispatch('loadServicesList')
    dispatch('cleanDotsAddress')
  },

  updateCurrentDate: debounce(({ commit, getters }, offset = 0) => {
    commit('updateCurrentDate', getCurrentDateObj(+getters.selectedCity.timezone, offset))
  }, 100),

  // Загрузка списка платных услуг
  loadServicesList: ({ state, getters, commit, dispatch }) => {
    const params = {
      type: 0,
      cityId: getters.selectedCity.id,
      isLegal: +getters.user.isLegalEntity,
    }

    OrderService.getServices(params).then(data => {
      commit('createServices', data)

      if (state.deliveryObject && state.deliveryObject.payServices.length) {
        state.deliveryObject.payServices.forEach(serviceAlias => {
          const service = state.services.find(serviceItem => serviceItem.alias === serviceAlias)

          if (service) {
            commit('toggleService', service.id)
          }
        })
      }

      dispatch('calculatePrice')
    })
  },
  // Проверяем сможет ли курьер успеть к точкам заказа за отведенное время
  checkEnoughTime: debounce(async ({ state, getters, commit }) => {
    let isSetCoords = true

    const Dots = state.order.dots.map((dot, index) => {
      if (dot.address && dot.lat && !getters.isYandexForm) {
        return {
          lat: dot.lat,
          lng: dot.lng,
          dateFrom: getters.formattedDates[index][0],
          dateTo: getters.formattedDates[index][1],
        }
      }

      isSetCoords = false
      return false
    })

    if (isSetCoords) {
      try {
        const response = await AddressService.getDistanceForOnFoot(qs.stringify({ Dots }))

        commit('setNotEnoughTime', response?.dot)
      } catch (e) {
        console.error(e, 'Не удалось рассчитать возможность доставки за определенное время')
      }
    } else {
      commit('setNotEnoughTime')
    }
  }, 100),

  getDistanceFromMetro({ state, commit }, index) {
    const data = {
      metro_id: state.order.dots[index].metroId,
      city_id: state.order.city,
      lat: state.order.dots[index].lat,
      lng: state.order.dots[index].lng,
    }

    AddressService.getDistanceFromMetro(data)
      .then(response => {
        commit('updateDot', {
          dot: state.order.dots[index],
          data: { key: 'distanceFromMetro', value: response.distance_from_metro },
        })
      })
      .catch(response => {
        console.error(response, 'Не удалось изменить метро.')
      })
  },

  async getClosestMetro({ commit }, { dot, cityId }) {
    const closestMetro = await getClosestMetro(dot, cityId)

    commit('updateDot', { dot, data: closestMetro })
  },

  updateFixPriceStatus({ commit, dispatch }, value) {
    commit('updateState', { key: 'fixPriceStatus', value })
    dispatch('calculatePrice')
  },

  blockOrderButton({ commit }) {
    commit('setStateToOrderButton', true)
  },

  setCountDown({ state }) {
    if (state.approveUser.timeLeft < 1) state.approveUser.timeLeft = 30

    const timer = setInterval(() => {
      state.approveUser.timeLeft -= 1

      if (state.approveUser.timeLeft <= 0) {
        clearInterval(timer)
      }
    }, 1000)
  },

  moveToOrdersList({ state }) {
    window.location = state.additional.isApp
      ? `http://app.redirect/shopMyOrders?token=${encodeURI(state.appToken)}`
      : '/'
  },
}
